import { ScrollArea } from "@/components/ui/scroll-area";
import { Message } from "@/types/chat.ts";
import React, { useRef } from "react";
import ChatMessage from "./ChatMessage";
import Suggestions from "./Suggestions";

interface ChatViewProps {
  messages: Message[];
  suggestions?: string[];
  onSuggestionSelect?: (suggestion: string) => void;
  embedded?: boolean;
}

const ChatView: React.FC<ChatViewProps> = ({
  messages,
  suggestions = [],
  onSuggestionSelect,
  // embedded = false,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // const scrollToBottom = () => {
  //   messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  // useEffect(() => {
  //   if (embedded) {
  //     return;
  //   }

  //   scrollToBottom();
  // }, [messages, embedded]);

  return (
    <ScrollArea className="h-full">
      <div className="flex flex-col space-y-8 max-w-5xl mx-auto mt-4 pb-24">
        {messages.map((message, index) => (
          <ChatMessage
            key={message.id}
            message={message}
            isLast={index === messages.length - 1}
          />
        ))}

        {messages.length > 0 && suggestions.length > 0 && (
          <div className="px-6 pb-4">
            <Suggestions
              suggestions={suggestions}
              onSelect={onSuggestionSelect!}
            />
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>
    </ScrollArea>
  );
};

export default ChatView;
